module.exports = {
  title: 'Fractal Glass with React Native Skia 🎨',
  author: 'Enzo Manuel Mangano',
  date: '2023-12-13',
  slug: 'fractal-glass',
  tags: ['skia'],
};
